function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M83.93,92.22l-31.93-7.6s-3.67-1.27-4.26-7.66c0,0-.96-31.88,1.02-46.5,0,0,.27-7.21,16.86-8.67,0,0,2.22-19.88-5.4-21.1C60.22,.69,52.87-.06,42.54,0,32.34,0,24.62,.59,24.62,.59c-7.63,1.23-5.4,21.1-5.4,21.1,16.59,1.46,16.86,8.67,16.86,8.67,1.98,14.62,1.02,46.5,1.02,46.5-.59,6.39-4.26,7.66-4.26,7.66L.91,92.13c-2.5,2.97,.93,5.89,.93,5.89l39.69,.15v.1l41.47-.15s3.43-2.92,.93-5.89Z"
})));

var SvgScrapRailPlain = function SvgScrapRailPlain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84.84 98.26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrapRailPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scrap-rail-plain.292f11a7.svg";
export { ForwardRef as ReactComponent };